import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import api, { extractError } from "@/lib/api";

export default function VerifyEmail() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api.post("/auth/verify-email", { token })
      .then(() => setState("ok"))
      .catch((e) => { setState("err"); setMsg(extractError(e)); });
  }, [token]);

  return (
    <div className="max-w-md mx-auto py-10" data-testid="verify-email-page">
      <Card className="p-8 text-center space-y-4">
        {state === "loading" && (
          <>
            <Loader2 className="mx-auto animate-spin text-primary" size={48} />
            <p className="urdu-naskh">تصدیق ہو رہی ہے…</p>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle className="mx-auto text-emerald-600" size={48} />
            <h1 className="urdu-naskh text-2xl font-semibold text-primary">ای میل تصدیق ہو گئی</h1>
            <Button asChild className="bg-primary"><Link to="/">مرکزی صفحہ پر جائیں</Link></Button>
          </>
        )}
        {state === "err" && (
          <>
            <XCircle className="mx-auto text-destructive" size={48} />
            <h1 className="urdu-naskh text-2xl font-semibold text-destructive">تصدیق نہیں ہو سکی</h1>
            <p className="urdu-naskh text-sm text-muted-foreground">{msg}</p>
            <Button asChild variant="outline"><Link to="/">واپس</Link></Button>
          </>
        )}
      </Card>
    </div>
  );
}
